<!--  -->
<template>
  <div class="map-popup">
    <div class="main">
      <div class="clearfix header">
        <div class="left title">
          <i style="vertical-align: middle;" class="iconfont icon-yizhangtu3"></i>
          <span style="vertical-align: middle;" class="popupProtitle">{{ defaultDsiplayLabel }}</span>
        </div>
        <i class="iconfont icon-cha right" onclick="closePopup()"></i>
      </div>
      <div class="line" style="width: 370px; height: 2px;"></div>
      <div class="table-content">
        <el-scrollbar style="width:100%;height:100%;">
          <div>
            <table>
              <tbody>
                <tr v-for="(item, index) in propertiesArray" :key="index" v-show="item.fieldalias !== '主键'">
                  <td width="120px">{{ item.fieldalias }}</td>
                  <td width="250px">{{ item.fieldvalue }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-scrollbar>
      </div>
      <div class="clearfix coverage">
        <div class="left">当前图层：{{ queryLayerName }}</div>
        <div
          class="right details"
          onclick="zoomInEventHandler()"
          v-show="this.logicLayerInfo.layerBusinessType === '9003' || this.logicLayerInfo.layerBusinessType === '9002'"
        >
          <i class="iconfont icon-search1"></i>
          <span>缩放至</span>
          <!--  <el-button type="primary" size="mini" style="line-height: 9px;cursor: pointer;">项目详情</el-button> -->
        </div>
      </div>
    </div>
    <div class="triangle">
      <div class="popup-tip"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
Vue.prototype.$event = Vue.prototype.$event || new Vue()

export default {
  components: {},
  props: {},
  data() {
    return {
      //
      properties: []
    }
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    const _this = this
    window.closePopup = function () {
      _this.map.closePopup()
      _this.map.resultHighlightLayerGroup.clearLayers()
    }
    window.viewSWDetails = function () {
      bus.$emit('viewSWDetails', _this.viewSWDetails)
    }

    window.zoomInEventHandler = function () {
      const geoArray = _this.map.resultHighlightLayerGroup.getLayers()
      if (geoArray.length > 0) {
        for (let j = 0; j < geoArray.length; j++) {
          const layer = geoArray[j]
          _this.map.fitBounds(layer.getBounds())
        }
      }
    }
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    //
  },
  methods: {}
}
</script>
<style scoped>
/* @import url(); 引入css类 */
* {
  box-sizing: border-box;
}
.line {
  background: linear-gradient(90deg, #2e89f8 10%, #2e89f8 10%);
}
.map-popup {
  width: 379px;
  height: 235px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 5px;
  /* box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4); */
  position: relative;
}
.clearfix:after {
  content: '\20';
  display: block;
  height: 0;
  clear: both;
}
.clearfix {
  zoom: 1;
}
.triangle {
  width: 40px;
  height: 20px;
  position: absolute;
  left: 50%;
  margin-left: -20px;
  overflow: hidden;
  pointer-events: none;
  bottom: -20px;
}
.popup-tip {
  background: white;
  color: #333;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.popupProtitle {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
  display: inline-block;
}
.header {
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
  color: rgba(51, 51, 51, 1);
}
.header > .iconfont {
  font-size: 20px;
  font-weight: normal;
  color: #999999;
  cursor: pointer;
}
.title .iconfont {
  color: rgb(46, 137, 248);
  margin-right: 5px;
  font-weight: normal;
  width: 120px;
  overflow: hidden;
  white-space: keep-all;
  text-overflow: ellipsis;
}
.table-content {
  height: 170px;
  border-bottom: 1px solid #cccccc;
  border-top: 0px solid #cccccc;
}
.el-scrollbar /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
    margin-right: 0!important;
}

.table-content table {
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: rgba(53, 53, 53, 1);
  border-collapse: collapse;
  border-spacing: 0px;
}
.table-content table td {
  border: 1px solid rgba(204, 204, 204, 1);
  padding: 5px 10px;
}
.table-content table td:first-child {
  background-color: #f5f6f8;
  text-align: right;
  color: #666666;
}
.table-content table tr:last-child td {
  border-bottom: none;
}
.table-content table tr:first-child td {
  border-top: none;
}
.coverage {
  color: #666666;
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
}
.details {
  cursor: pointer;
  padding-right: 10px;
}
.details span {
  text-decoration: underline;
  color: rgba(102, 102, 102, 1);
}
</style>
